export default __webpack_public_path__ + "static/media/searchicon.fcd5dddc.svg";